import { getPveInstance } from '@pvplevelup/core/dist/interfaces/Pve/IPveInstance';
import { IPve } from '@pvplevelup/core/dist/interfaces/Pve/IPve';
import { IPvePull } from '@pvplevelup/core/dist/interfaces/Pve/IPvePull';
import { GameStatus } from '@pvplevelup/core/dist/interfaces/Game/IGame';
import { ClassColorsObject } from 'utilities/team_colors';

/** Damage bars use the player's class color; red when the class isn't known. */
export const PVE_DAMAGE_COLOR = '#e53935';
export const getPveDamageColor = (charClass?: string | null) => (charClass && (ClassColorsObject as Record<string, string>)[charClass]) || PVE_DAMAGE_COLOR;

export const PULL_COLORS = {
  trash: '#757575',
  kill: '#43a047',
  wipe: '#e53935',
  active: '#fb8c00',
};

/** 1:05:09 or 12:34 */
export function formatPveDuration(seconds?: number | null) {
  if(seconds == null || isNaN(seconds))
    return '-';
  const s = Math.max(0, Math.round(seconds));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  const pad = (n: number) => String(n).padStart(2, '0');
  return h > 0 ? `${h}:${pad(m)}:${pad(sec)}` : `${m}:${pad(sec)}`;
}

/** 1.2M, 340k, 812 */
export function formatPveNumber(value?: number | null) {
  if(value == null || isNaN(value))
    return '-';
  const abs = Math.abs(value);
  if(abs >= 1000000)
    return `${(value / 1000000).toFixed(abs >= 10000000 ? 1 : 2)}M`;
  if(abs >= 10000)
    return `${Math.round(value / 1000)}k`;
  return Math.round(value).toLocaleString();
}

export const getPveInstanceName = (pve: IPve) => pve.instanceName || getPveInstance(pve.instance || 0)?.name || 'Unknown dungeon';

export function getPullLabel(pull: IPvePull) {
  if(pull.type != 'boss')
    return 'Trash';
  return pull.attempt && pull.attempt > 1 ? `${pull.name} #${pull.attempt}` : pull.name;
}

export function getPullColor(pull: IPvePull) {
  if(pull.type != 'boss')
    return PULL_COLORS.trash;
  if(pull.result == 'kill')
    return PULL_COLORS.kill;
  if(pull.result == 'wipe')
    return PULL_COLORS.wipe;
  return PULL_COLORS.active;
}

export function getPveRunState(pve: IPve): {label: string, color: string} {
  if(pve.status == GameStatus.Active)
    return {label: 'In progress', color: PULL_COLORS.active};
  if(pve.completed)
    return {label: 'Cleared', color: PULL_COLORS.kill};
  if(pve.status == GameStatus.Aborted)
    return {label: 'Stopped', color: PULL_COLORS.trash};
  return {label: 'Not cleared', color: PULL_COLORS.wipe};
}

export const getPveModeLabel = (hardMode?: boolean | null) => hardMode ? 'Hard' : 'Normal';
